import { render, staticRenderFns } from "./MerchandiseList.vue?vue&type=template&id=47ea9404&scoped=true&"
import script from "./MerchandiseList.vue?vue&type=script&lang=js&"
export * from "./MerchandiseList.vue?vue&type=script&lang=js&"
import style0 from "./MerchandiseList.vue?vue&type=style&index=0&id=47ea9404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea9404",
  null
  
)

export default component.exports